<template>
    <div class="intelligent-personnel">
        <el-tabs tab-position="right" v-model="userInfoTab">
            <el-tab-pane label="基本信息" name="baseInfo">
                <base-info :adminuser_id="adminuserId" :adminuser_name="adminuserName" />
            </el-tab-pane>
            <el-tab-pane label="工作信息" name="workInfo">
                <work-info :adminuser_id="adminuserId" :adminuser_name="adminuserName" />
            </el-tab-pane>
            <el-tab-pane label="个人信息" name="personalInfo">
                <personal-info :adminuser_id="adminuserId" :adminuser_name="adminuserName" />
            </el-tab-pane>
            <el-tab-pane label="学历信息" name="educationInfo">
                <education-info :adminuser_id="adminuserId" :adminuser_name="adminuserName" />
            </el-tab-pane>
            <el-tab-pane label="银行卡信息" name="bankCardInfo">
                <bank-card :adminuser_id="adminuserId" :adminuser_name="adminuserName" />
            </el-tab-pane>
            <el-tab-pane label="合同信息" name="contractInfo">
                <contract-info :adminuser_id="adminuserId" :adminuser_name="adminuserName" />
            </el-tab-pane>
            <el-tab-pane label="紧急联系人信息" name="contactInfo">
                <contact-info :adminuser_id="adminuserId" :adminuser_name="adminuserName" />
            </el-tab-pane>
            <el-tab-pane label="家庭信息" name="familyInfo">
                <family-info :adminuser_id="adminuserId" :adminuser_name="adminuserName" />
            </el-tab-pane>
            <el-tab-pane label="个人材料信息" name="personalMaterialsInfo">
                <personal-materials :adminuser_id="adminuserId" :adminuser_name="adminuserName" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import BaseInfo from './UserInfoTab/BaseInfo';
import WorkInfo from './UserInfoTab/WorkInfo';
import PersonalInfo from './UserInfoTab/PersonalInfo';
import EducationInfo from './UserInfoTab/EducationInfo';
import BankCard from './UserInfoTab/BankCardInfo.vue';
import ContractInfo from './UserInfoTab/ContractInfo';
import ContactInfo from './UserInfoTab/ContactInfo';
import FamilyInfo from './UserInfoTab/FamilyInfo';
import PersonalMaterials from './UserInfoTab/PersonalMaterialsInfo';
export default {
    name: 'IntelligentPersonnel',
    components: { BaseInfo, WorkInfo, PersonalInfo, EducationInfo, BankCard, ContractInfo, ContactInfo, FamilyInfo, PersonalMaterials },
    props: {
        adminuser_id: {
            type: Number
        },
        adminuser_name: {
            type: String
        }
    },
    data() {
        return {
            userInfoTab: 'baseInfo',
            adminuserId: null,
            adminuserName: ''
        }
    },
    watch: {
        adminuser_id: {
            immediate: true,
            handler(n, o) {
                if (n !== o) {
                    this.$nextTick(_ => {
                        this.adminuserId = n
                    });
                }
            }
        },
        adminuser_name: {
            immediate: true,
            handler(n, o) {
                this.adminuserName = ''
                if (n !== o) {
                    this.$nextTick(_ => {
                        this.adminuserName = n
                    });
                }
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/authority/IntelligentPersonnel.vue